import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/shared/lib/supabase';
import { message } from 'antd';

export interface Form {
  id: string;
  name: string;
  description: string | null;
  form_url: string;
  form_fields: any;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function useForms() {
  return useQuery({
    queryKey: ['forms'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('forms')
        .select('*')
        .eq('is_active', true)
        .order('name');

      if (error) {
        console.error('Error fetching forms:', error);
        message.error('Erro ao carregar formulários');
        throw error;
      }

      return data as Form[];
    },
  });
}
